import item from '../CollectionItems/muralForTheTerracePlazaHotel';

export default {
  location: 'nu-bleu-ii',
  filename: 'nu-bleu-ii-matisse',
  title: item.name,
};
